export default "__VITE_PUBLIC_ASSET__6cf37415__"